/*!
 * Copyright 2024 Cognite AS
 */

/**
 * A corner of the anything.
 */

export enum Corner {
  TopRight,
  TopLeft,
  BottomLeft,
  BottomRight
}
